<common-environment-header
  *ngIf="!isProd"
  [applicationVersion]="applicationVersion$ | async"
></common-environment-header>

<meta name="version" [content]="applicationVersion" />

<div class="header-wrapper" #header data-cy="goab-header">
  <goab-microsite-header type="live" [version]="appVersionNumber"></goab-microsite-header>
  <common-header-navigation
    [headerTitle]="isMobile ? 'FSCD' : 'Family Support for Children with Disabilities (FSCD)'"
    [userNavigation]="userNavigation"
    [testRole]="fscdTestRole"
    [isMobile]="isMobile"
    [loginIdp]="keycloakIdpName"
    [albertaCaAccountUrl]="albertaCaAccountUrl"
    [hideBadgeStatus]="true"
  ></common-header-navigation>
</div>

<div #contentSection class="content-section">
  <div class="goab-banner" iesGoaBanner role="banner">
    <div class="back-to-dashboard" *ngIf="isApplicationPage">
      <a
        class="link"
        role="link"
        (click)="goBackToDashboard()"
        (keydown.space)="goBackToDashboard()"
        (keydown.enter)="goBackToDashboard()"
      >
        <span class="arrow material-icons">arrow_back</span>&nbsp;
        <span class="text" tabindex="0">Back to homepage</span>
      </a>
      <hr />
    </div>
    <h1 id="intake-section-label">Family Support for Children with Disabilities (FSCD)</h1>
    <div class="descriptor" id="intake-section-sublabel">Apply for FSCD</div>
  </div>
  <maintenance-mode-banner appName="FSCD"></maintenance-mode-banner>
  <common-notification-banner
    [bannerMessage]="notificationMessage"
    [bannerType]="notificationType"
    [startDate]="notificationStartDate"
    [endDate]="notificationEndDate"
    *ngIf="!maintenanceBannerActive"
  >
  </common-notification-banner>
  <div [hidden]="!loading">
    <div>
      <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
    </div>
  </div>
  <main class="goab-content-section" aria-labelledby="intake-section-label intake-section-sublabel">
    <router-outlet (activate)="onActivate($event)" #appOutlet="outlet"> </router-outlet>
  </main>
</div>
<goab-app-footer>
  <goab-app-footer-meta-section slot="meta">
    <a href="https://alberta.ca" target="_blank">Go to Alberta.ca</a>
  </goab-app-footer-meta-section>
</goab-app-footer>
